const valuesPolyfill = function values(object) {
  return Object.keys(object).map(key => object[key]);
};

Object.values = Object.values || valuesPolyfill;



// WEBPACK FOOTER //
// ./src/utils/Polyfills.js